import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function useScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const prev = window.history.scrollRestoration;
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    return () => {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = prev ?? 'auto';
      }
    };
  }, []);

  useLayoutEffect(() => {
    if (hash) return;
    const goTop = () => window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    goTop();
    requestAnimationFrame(goTop);
  }, [pathname]);
}
